import {
  closeOverlay,
  openOverlay,
} from "./OverlayManager";

// NapflixOS Command Center v8
// Lightweight command/quick menu runtime. UI is rendered separately.
const defaultCommands = [
  { id: "search", label: "Search" },
  { id: "tv-guide", label: "TV Guide" },
  { id: "ambient", label: "Ambient Mode" },
  { id: "system-status", label: "System Status" },
  { id: "restart", label: "Restart Napflix" },
  { id: "close", label: "Close" },
];

let commandCenterState = {
  open: false,
  selectedIndex: 0,
  commands: defaultCommands,
  openedAt: null,
};

const listeners = new Set();

const notifyListeners = () => {
  listeners.forEach((listener) => listener(commandCenterState));
};

const syncCommandCenterOverlay = () => {
  if (!commandCenterState.open) {
    closeOverlay("napflix-command-center");
    return;
  }

  openOverlay({
    id: "napflix-command-center",
    type: "command-center",
    priority: 80,
    modal: true,
    focusTrap: false,
    payload: {
      selectedIndex: commandCenterState.selectedIndex,
    },
  });
};

export function getCommandCenterState() {
  return commandCenterState;
}

export function setCommandCenterState(partial) {
  const nextCommands = partial.commands || commandCenterState.commands;
  const maxIndex = Math.max(0, nextCommands.length - 1);

  commandCenterState = {
    ...commandCenterState,
    ...partial,
    commands: nextCommands,
    selectedIndex: Math.min(
      Math.max(partial.selectedIndex ?? commandCenterState.selectedIndex, 0),
      maxIndex
    ),
  };

  syncCommandCenterOverlay();
  notifyListeners();
}

export function subscribeCommandCenter(listener) {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

export function openCommandCenter() {
  setCommandCenterState({
    open: true,
    selectedIndex: 0,
    openedAt: Date.now(),
  });
}

export function closeCommandCenter() {
  setCommandCenterState({
    open: false,
    openedAt: null,
  });
}

export function toggleCommandCenter() {
  if (commandCenterState.open) {
    closeCommandCenter();
    return;
  }

  openCommandCenter();
}
